import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import { Config } from "@forgerock/javascript-sdk";
import { initializeGoogleTagManager } from "utils/GoogleTagManager/GoogleTagManager";

initializeGoogleTagManager();

Config.set({
  clientId: process.env.REACT_APP_WEB_OAUTH_CLIENT,
  redirectUri: process.env.REACT_APP_FR_REDIRECT_URI,
  scope: process.env.REACT_APP_SCOPE,
  serverConfig: {
    baseUrl: process.env.REACT_APP_AM_URL ? process.env.REACT_APP_AM_URL : "",
    timeout: 10000,
  },
  realmPath: process.env.REACT_APP_REALM_PATH,
  oauthThreshold: 60000,
});

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}
const root = ReactDOM.createRoot(rootElement);
const persistor = persistStore(store);

root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
);

reportWebVitals();